import GameIds from '../../hub/data/GameIds';

export const GAME_ID = GameIds.SHADES_OF_MEANING;

// GAME SETTINGS
export const MAX_TRIES_PER_QUESTION = 1;
export const QUESTIONS_THRESHOLD_TO_MASTER = 4;
export const QUESTIONS_PER_LEVEL = 6;
export const TOTAL_LEVELS = 5;
export const ZAPS_TO_MASTER = 10;
export const BITES_PER_ROUND = 3;
// -----------------------------------------------------------------------------
// GAME MODE ENUM
export const SCREENS = {
  STANDARD: 'standard',
  INSTRUCTION: 'instruction',
  PRACTICE: 'practice',
  PROGRESS: 'progress',
  LOADING: 'loading',
};
// -----------------------------------------------------------------------------
// ALEX STATE ENUM
// Alex actions
export const ALEX_STATES = {
  INACTIVE: 0,
  ACTIVE: 1,
  SPEAKING: 2,
};
// -----------------------------------------------------------------------------
// PAYOFF ANIMATION
export const TOTAL_ACORNS = 10;
export const ACORN_TOP = -50;
export const ACORN_BOTTOM = 600;
export const ACORN_ANIMATION_DURATION = 500;
export const ACORN_ANIMATION_DELAY = 350;
export const LEAVES_BOUNCE_OFF_SET = 10;
export const LEAVES_BOUNCINESS = 20;
// -----------------------------------------------------------------------------
// SQUIRREL ANIMATION
export const TREE_POSITION_X = 360; // the x position of the tree relative to the starting x position of the squirrel.
export const TOP_TREE_POSITION_Y = -600;
export const SQUIRREL_GROUND_POS_Y = 0;
export const SQUIRREL_RUNNING_TIME = 400;
export const SQUIRREL_CLIMBING_TIME = 1500;
// -----------------------------------------------------------------------------
export const WORD_STATUS = {
  CORRECT: 'correct',
  INCORRECT: 'incorrect',
  UNSELECTED: 'unselected',
  AVAILABLE: 'available',
  SELECTED: 'selected',
};
// -----------------------------------------------------------------------------
export const REWARD = {
  EMPTY: 0,
  BITES: 1,
  ZAPS: 2,
};
// -----------------------------------------------------------------------------
export const DROPZONE_STATUS = {
  CORRECT: 'correct',
  INCORRECT: 'incorrect',
  AVAILABLE: 'available',
  USED: 'used',
};
// -----------------------------------------------------------------------------
export const ACTIONS = {
  // NAVEGATOR ACTIONS
  CHANGE_SCREEN: 'CHANGE_SCREEN',

  // HEADER ACTIONS
  CHANGE_ALEX_STATE: 'CHANGE_ALEX_STATE',

  // SESSION ACTIONS
  INIT_SHADES_SESSION: 'INIT_SHADES_SESSION',
  START_NEW_ROUND: 'START_NEW_ROUND',
  UPDATE_GAME_PROGRESS: 'UPDATE_GAME_PROGRESS',
  ADVANCE_QUESTION: 'ADVANCE_QUESTION',
  INCREASE_INCORRECT_ANSWER_COUNT: 'INCREASE_INCORRECT_ANSWER_COUNT',
  INCREASE_CORRECT_ANSWER_COUNT: 'INCREASE_CORRECT_ANSWER_COUNT',
  MARK_ONBOARDING_AS_COMPLETE: 'MARK_ONBOARDING_AS_COMPLETE',
  SAVE_LAST_ROUND_FOR_PROGRESS_SCREEN: 'SAVE_LAST_ROUND_FOR_PROGRESS_SCREEN',
  ADVANCE_PROGRESS_POINTER: 'ADVANCE_PROGRESS_POINTER',
  TRY_UNLOCKING_LEVEL: 'TRY_UNLOCKING_LEVEL',
  // INTERACTIVE ACTIONS
  LOCK_INTERATION: 'LOCK_INTERATION',
  UNLOCK_INTERATION: 'UNLOCK_INTERATION',

  // PROGRESS SCREEN ACTIONS
  SHOW_ANIMATION_OF: 'SHOW_ANIMATION_OF',
  SHOW_BOWL_OF: 'SHOW_BOWL_OF',

  // INSTRUCTION VIEW ACTIONS...
  NEXT_INSTRUCTION_DEFINITION: 'NEXT_INSTRUCTION_DEFINITION',

  // STANDARD VIEW ACTIONS...
  // word panel actions...
  CREATE_WORD_PANEL_DATA: 'CREATE_WORD_PANEL_DATA',
  SET_ALL_PANEL_TO_CORRECT: 'SET_ALL_PANEL_TO_CORRECT',
  AUTO_COMPLETE_THIS_SET: 'AUTO_COMPLETE_THIS_SET',
  // draggable actions...
  SET_AS_INCORRECT: 'SET_AS_INCORRECT',
  RESET_DRAGGABLE_STATUS: 'RESET_DRAGGABLE_STATUS',
  SHOW_DESCRIPTIONS_FOR_ALL_INCORRECT_WORDS: 'SHOW_DESCRIPTIONS_FOR_ALL_INCORRECT_WORDS',
  SHOW_DESCRIPTION_OF_TARGET_WORD_ID: 'SHOW_DESCRIPTION_OF_TARGET_WORD_ID',
  RELEASE_DRAGGABLE: 'RELEASE_DRAGGABLE',
  SELECT_DRAGGABLE: 'SELECT_DRAGGABLE',
  INIT_DRAGGABLE_POSITION: 'INIT_DRAGGABLE_POSITION',
  UPDATE_DRAGGABLE_POSITION: 'UPDATE_DRAGGABLE_POSITION',
  // position marker actions...
  UPDATE_MARKER_POSITION: 'UPDATE_MARKER_POSITION',

  // PRACTICE VIEW ACTIONS...
  CREATE_PRACTICE_DATA: 'CREATE_PRACTICE_DATA',
  ATTACH_WORD_TO_DROPZONE: 'ATTACH_WORD_TO_DROPZONE',
  DETACH_WORD_FROM_DROPZONE: 'DETACH_WORD_FROM_DROPZONE',
  SELECT_PRACTICE_WORD: 'SELECT_PRACTICE_WORD',
  TOGGLE_DROPZONE_SELECTION: 'TOGGLE_DROPZONE_SELECTION',
  SHOW_RESULT: 'SHOW_RESULT',
};

export const QUESTION_TYPE = {
  PRACTICE: 'practice',
  STANDARD: 'standard',
  SELF_CORRECT: 'self-correct',
};
